import { defineComponent, inject, ref, computed, openBlock, createElementBlock, withModifiers, normalizeClass, createElementVNode, unref, createVNode, createCommentVNode, renderSlot } from "vue";
import Checkbox from "../checkbox/Checkbox.vue.js";
import { DROPDOWN_KEY } from "./type.js";
const _hoisted_1 = { class: "dropdown-item__content" };
const _hoisted_2 = { class: "dropdown-item__content-inner" };
const _hoisted_3 = {
  key: 1,
  class: "dropdown-item__icon"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "DropdownItem",
  props: {
    value: { default: void 0 },
    forceShowCheckbox: { type: Boolean, default: false },
    isAllItems: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const { click, toggle, toggleAll, multiple, isItemSelected, allSelected, someSelected } = inject(DROPDOWN_KEY, {
      effect: ref("light"),
      click: () => {
      },
      toggle: () => {
      },
      toggleAll: () => {
      },
      multiple: ref(false),
      selectedValues: ref([]),
      isItemSelected: () => false,
      allSelected: ref(false),
      someSelected: ref(false)
    });
    const handleCheckboxClick = () => {
      if (props.isAllItems) {
        toggleAll();
        return;
      }
      toggle(props.value);
    };
    const isSelected = computed(() => {
      if (props.isAllItems) {
        return allSelected.value;
      }
      if (!props.value) return false;
      return isItemSelected(props.value);
    });
    const isIndeterminate = computed(() => {
      if (props.isAllItems) {
        return someSelected.value;
      }
      return false;
    });
    const handleClick = () => {
      if (props.isAllItems) {
        toggleAll();
        return;
      }
      toggle(props.value);
      if (!unref(multiple)) {
        click(props.value);
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          "dropdown-item",
          {
            "dropdown-item--selected": isSelected.value,
            "dropdown-item--show-checkbox": __props.forceShowCheckbox
          }
        ]),
        onClick: withModifiers(handleClick, ["stop"])
      }, [
        createElementVNode("div", _hoisted_1, [
          createElementVNode("div", _hoisted_2, [
            unref(multiple) ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "dropdown-item__checkbox",
              onClick: withModifiers(handleCheckboxClick, ["stop"])
            }, [
              createVNode(Checkbox, {
                "model-value": isSelected.value,
                indeterminate: isIndeterminate.value,
                size: "sm"
              }, null, 8, ["model-value", "indeterminate"])
            ])) : createCommentVNode("", true),
            _ctx.$slots["prefix-icon"] ? (openBlock(), createElementBlock("div", _hoisted_3, [
              renderSlot(_ctx.$slots, "prefix-icon", {}, void 0, true)
            ])) : createCommentVNode("", true),
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ])
        ])
      ], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=DropdownItem.vue2.js.map
